module.exports = __webpack_public_path__ + "img/youtube_icone.9b18a8f3.png";